export default __webpack_public_path__ + "4e088551180b8eb7b9fdce6c987ef396.svg";